





















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { clientsModule, compilationsModule } from '@/store';
import { CompilationThingDTO, FilterDTO } from '@/api';
import CatalogItemPrice from '@/components/CatalogItemPrice.vue';
import LookDynamicCard from '@/components/looks/LookDynamicCard.vue';
import BackgroundClipping from '@/components/BackgroundClipping.vue';
import ThingTemperatureInput from '@/components/things/ThingTemperatureInput.vue';
import services from '@/services';

@Component({
  name: 'compilation-things-page',
  components: {
    CatalogItemPrice,
    LookDynamicCard,
    BackgroundClipping,
    ThingTemperatureInput,
  },
})
export default class compilationThings extends Vue {
  commentModalVisible = false;

  comment = '';

  lookTemperature: [number, number] = [-60, 60];

  categories: FilterDTO[] = [];

  thingForm: {
    temperature?: [number, number];
    categoryId?: string;
  } | null = null;

  get client() {
    return clientsModule.model;
  }

  get compilation() {
    return compilationsModule.model;
  }

  get things() {
    return compilationsModule.things.filter(thing => !thing.clientItemId || thing.inWardrobe);
  }

  get looks() {
    return compilationsModule.looks;
  }

  get sumPrice() {
    return this.things.reduce((sum, item) => sum
      + (!item.deleted && item.price ? item.price : 0), 0);
  }

  get groupedThingsByLook() {
    return compilationsModule.groupedThingsByLook;
  }

  get selectedThing() {
    return compilationsModule.things
      .find(thing => thing.id === Number(this.$route.query.selectedThing));
  }

  get selectedLook() {
    return compilationsModule.groupedThingsByLook
      .find(look => look.id === Number(this.$route.query.selectedLook));
  }

  get finished() {
    return this.compilation?.status === 'FINISHED';
  }

  async created() {
    if (this.client && this.client.id != null) {
      const { data: categories } = await services.catalogService()
        .catalogEndpointGetClientCategoryNames(this.client.id);
      this.categories = categories;
    }
  }

  @Watch('selectedThing.id', { immediate: true })
  onSelectedThingChange() {
    if (this.selectedThing) {
      this.resetForm();
    } else {
      this.thingForm = null;
    }
  }

  resetForm() {
    if (this.selectedThing) {
      this.thingForm = {
        categoryId: String(this.selectedThing.categoryId),
        temperature: [
          Number(this.selectedThing.temperatureFrom),
          Number(this.selectedThing.temperatureTo),
        ],
      };
    }
  }


  async saveThing() {
    if (this.thingForm && this.selectedThing) {
      try {
        const brands = await services.catalogService().catalogEndpointGetFilterNames('BRAND').then(({ data }) => data);
        const suppliers = await services.catalogService()
          .catalogEndpointGetSuppliersList().then(({ data }) => data);
        const brandId = brands.find(b => b.name === this.selectedThing?.brand)?.id;
        const supplierId = suppliers.find(s => s.name === this.selectedThing?.store)?.id;
        services.compilationsApi()
          .compilationEndpointUploadThing(
            this.selectedThing.id,
            Number(this.$route.params.compilationId),
            this.selectedThing.link,
            'CLOTHES',
            '',
            String(brandId),
            String(supplierId),
            46,
            this.selectedThing.size as string,
            this.selectedThing.price,
            this.selectedThing.priceDiscount,
            Number(this.thingForm.categoryId),
            this.thingForm.temperature && String(this.thingForm.temperature[0]),
            this.thingForm.temperature && String(this.thingForm.temperature[1]),
            undefined,
            undefined,
            undefined,
          );
        compilationsModule
          .fetchCompilation({ compilationId: Number(this.$route.params.compilationId) });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  }

  @Watch('selectedLook.id', { immediate: true })
  onSelectedLookChange() {
    if (this.selectedLook?.temperatureFrom && this.selectedLook?.temperatureTo) {
      this.lookTemperature = [this.selectedLook.temperatureFrom, this.selectedLook.temperatureTo];
    }
  }

  openCommentModal() {
    this.commentModalVisible = true;
    this.comment = this.compilation?.stylistComment || '';
  }

  saveComment() {
    if (compilationsModule.model?.id != null) {
      compilationsModule.saveComment({
        compilationId: compilationsModule.model.id,
        stylistComment: this.comment,
      });
      this.commentModalVisible = false;
    }
  }

  selectThing(id: number) {
    this.$router.push({ query: { selectedThing: String(id) } });
  }

  selectLook(id: number) {
    this.$router.push({ query: { selectedLook: String(id) } });
  }

  thingImg(thing: CompilationThingDTO) {
    return thing && thing.fileNames && thing.fileNames.length
      ? thing.fileNames[0].fileName
      : null;
  }

  getPrice(thing: CompilationThingDTO) {
    return thing.priceDiscount && thing.priceDiscount < (thing.price || 0)
      ? thing.priceDiscount : thing.price;
  }

  deleteThing() {
    this.$confirm('Вы уверены, что хотите удалить эту вещь?', 'Внимание!', {
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      type: 'warning',
    }).then(() => {
      if (this.selectedThing?.id && this.compilation?.id != null) {
        compilationsModule.deleteThing({
          compilationId: this.compilation?.id,
          thingId: this.selectedThing?.id,
        });
      }
      this.$message({
        type: 'success',
        message: 'Образ удалён',
      });
    });
  }

  deleteLook() {
    this.$confirm('Вы уверены, что хотите удалить данный образ?', 'Внимание!', {
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      type: 'warning',
    }).then(() => {
      if (this.selectedLook?.id != null && this.compilation?.id != null) {
        compilationsModule.deleteLook({
          compilationId: this.compilation?.id,
          compilationLookId: this.selectedLook?.id,
        });
      }
      this.$message({
        type: 'success',
        message: 'Образ удалён',
      });
    });
  }

  editThing(thingId: number) {
    this.$router.push({ name: 'compilation-edit-thing', params: { thingId: String(thingId) } });
  }

  editLook(lookId: number) {
    this.$router.push({ name: 'compilations-looks-edit', query: { selected: String(lookId) } });
  }

  async improveImage(imageUrl: string) {
    // eslint-disable-next-line no-console
    console.log(imageUrl);
    // if (this.form.categoryId) {
    //   thingsModule.saveThings([{
    //     ...this.form,
    //     categoryId: Number(this.form.categoryId),
    //     imageUrl,
    //     userId: clientsModule.model ? clientsModule.model.id : undefined,
    //   }]);
    // }
  }

  saveLook() {
    if (this.selectedLook && this.compilation?.id != null) {
      services.compilationsApi().compilationEndpointSaveLook(
        this.compilation.id,
        this.selectedLook.id,
        this.lookTemperature[0],
        this.lookTemperature[1],
      );
    }
  }
}
